function getSelectedCurrency() {
  let cookies = document.cookie.split("; ");
  let currency = cookies.find((row) => row.startsWith("cart_currency="));
  return currency ? currency.split("=")[1] : "CAD";
}

function getSelectedCountry() {
  // Prefer a country explicitly output by Liquid, when available.
  if (window.currentShopifyCountry) {
    return String(window.currentShopifyCountry).toUpperCase();
  }

  // Shopify normally exposes the active localization country here.
  if (window.Shopify && window.Shopify.country) {
    return String(window.Shopify.country).toUpperCase();
  }

  // Fallback for this store's US/CAN currency setup.
  const currency = String(getSelectedCurrency() || "").toUpperCase();

  if (currency === "USD") {
    return "US";
  }

  if (currency === "CAD") {
    return "CA";
  }

  return "";
}
 
let variantId = "";

function setVariant(){

    variantId = $('.product-variant-id').val();
    console.log("variantId:"+variantId);
    setprice();
    taperBinded()

    $(document).on('change', 'variant-selects select', function () {
    let attempts = 0;
    const checkVariant = setInterval(() => {
        let variantId_new = $('.product-variant-id').val();

        if (variantId_new && variantId_new !== variantId) {
        variantId = variantId_new;
        console.log('Variant changed:', variantId_new);

        clearInterval(checkVariant);
            setprice()
        }

        attempts++;
        if (attempts >= 10) {
        clearInterval(checkVariant);
        }
    }, 500);
    });

}

function setprice() {
  const variant = JSON.parse(
    document.querySelector('script[data-selected-variant]').textContent
  );

  let getPrice = $(".bold_option_total div span").text() || '0';

  // dollars → number
  let optionPrice = parseFloat(
    getPrice.replace(/[^0-9.]/g, '')
  );

  // guard NaN
  optionPrice = isNaN(optionPrice) ? 0 : optionPrice;

  // dollars → cents
  let optionPriceCents = Math.round(optionPrice * 100);

  // cents + cents
  let totalPrice = variant.price + optionPriceCents;

  console.log({
    variantId: variant.id,
    basePriceCents: variant.price,
    optionPriceCents,
    totalPrice
  });

  $(".pct_total_price").text(`$${(totalPrice / 100).toFixed(2)}`);
}

function buildDataAttrs(obj, region) {
  const r = obj[region] || {};
  let attrs = "";

  if (r.ALL) {
    attrs += ` data-${region}-all-price="${r.ALL.price}"`;
    attrs += ` data-${region}-all-index="${r.ALL.index}"`;
  }

  Object.keys(r).forEach(k => {
    if (k === "ALL") return;
    attrs += ` data-${region}-${k}-price="${r[k].price}"`;
    attrs += ` data-${region}-${k}-index="${r[k].index}"`;
  });

  return attrs;
}

let stickyWidth = "555";

$(window).on("resize", function () {
     stickyWidth = $sticky.outerWidth();
});

function handleSticky() {

  if (window.innerWidth <= 768) {
    // Reset styles for mobile
    $(".product_sticky").css({
      position: "",
      top: "",
      width: ""
    });
    return; // stop execution
  }

  const $container = $(".product_imageGallery_container");
  const $sticky = $(".product_sticky");

  const scrollTop = $(window).scrollTop();
  const containerTop = $container.offset().top;
  const containerHeight = $container.outerHeight();
  const stickyHeight = $sticky.outerHeight();
  const stickyWidth = $container.width();

  const startStick = containerTop;
  const endStick = containerTop + containerHeight - stickyHeight;

  if (scrollTop < startStick) {
    $sticky.css({
      position: "absolute",
      top: 187,
      width: stickyWidth + "px"
    });

  } else if (scrollTop >= startStick && scrollTop < endStick) {
    $sticky.css({
      position: "fixed",
      top: 20,
      width: stickyWidth + "px"
    });

  } else {
    $sticky.css({
      position: "absolute",
      top: containerHeight - stickyHeight,
      width: stickyWidth + "px"
    });
  }
}

$(window).on("scroll resize", handleSticky);

function importMeta() { 

    console.log("importMeta")
    let currency = getSelectedCurrency();
    let rawDataElement = $("#option-data");
    if (!rawDataElement.length) {
      return;
    }

   let productData = JSON.parse(
      document.getElementById("custom-product-json").textContent
    );

    let rawData = rawDataElement.html();
    console.log("rawData",rawData)
    let optionData = JSON.parse(rawData);


    /* TAPPER */
    let tapers = optionData.Tapers || [];
    let container = $("#taperCardsContainer");

    container.empty();
    tapers.forEach((taper, index) => {

      let variant = productData.variants[index];

      let salesPrice = '';

      if (variant) {
        let price = (variant.price / 100).toFixed(2);

        if (currency === 'CAD') {
          salesPrice = '$'+ price + ' CAD';
        } else {
          salesPrice = '$' + price + 'USD';
        }
      }
      

      let image_src = taper.image;
      let price = "";
      let fullprice = "";
      let value_key = "";
      
      let card = `
                <div class="sdt_card" 
                    data-value="${taper.name}" 
                    data-option-value-key="${value_key}">
                    <img class="sdt_headerImg" src="${image_src}" alt="${taper.name}">
                    <div class="sdt_radioBtnContainer">
                        <div class="sdt_radio_icon"></div>
                        <div class="sdt_discription">${taper.short}</div>
                    </div> 
                   <div class="ugw_prices">
                      <div class="ugw_salesPrice">${salesPrice}</div>
                    </div>
                </div>
                `;
      container.append(card);
    });

    var $hiddenForm = $(".product-form form"); // Hidden SC Products form
    var $hiddenQuantityInput = $hiddenForm.find("input[name='quantity']");
    if (!$hiddenQuantityInput.length) {
      $hiddenQuantityInput = $("<input>", {
        type: "number",
        name: "quantity",
        value: 1,
      }).appendTo($hiddenForm);
    } 

    $(".sdt_card").on("click", function () {
      $(".sdt_card").removeClass("active");
      $(this).addClass("active");
      let taper_type = $(this).data("value");
      $('input[name="properties[Taper]"]').val(taper_type)
    });

   /* add colors */

    let colours = optionData.Colour || [];
    let color_standard_container = $(".color-standard-container");
    let color_atlantis_container = $(".color-atlantis-container");
    let us_color_button_container = $(".us-color-button-container");
    let weatherShield_color_container = $(".weatherShield-color-container");

    color_standard_container.empty();
    color_atlantis_container.empty();

    us_color_button_container.empty();
    weatherShield_color_container.empty();


    colours.forEach((Colour) => {

      let color_card = `
        <div
          class="color-button ${Colour.name}"
          data-propertie="${Colour.name_properties}"
          data-index="${Colour.index}"
          data-color="${Colour.name.replace(/_/g, " ")}"
          data-image="${Colour.image}"
        >
          ${Colour.name.replace(/_/g, " ")}"
        </div>
      `;


      if(Colour.type == "fabric"){
        color_atlantis_container.append(color_card);
      }else if (Colour.type == "weatherShield"){
        weatherShield_color_container.append(color_card);
      }else if (Colour.type == "us-standard"){
        us_color_button_container.append(color_card);
      }else{
        color_standard_container.append(color_card);
      }
    });

    console.log("bind colors")
    bindColors()
    
    /* handels highlights */

    let handlesData = optionData.Handles || []; // Ensure Handles exist

    // Clear existing options
    console.log("add handels")
    $(".handle-options-container").empty();

    // Loop through each handle option and create the corresponding HTML
    handlesData.forEach((handle, index) => {
      let handlePrice = "";
      let value_key = "";
      let d_long = handle.short || '';
      let name_properties = handle.name_properties;

      let d_short = d_long.length > 100
        ? d_long.substring(0, 100).split(' ').slice(0, -1).join(' ') + '...'
        : d_long;

      let $handle_select = $(`select[name="${name_properties}"]`);
      let $handle_option = $handle_select.find(`option[data-option_value_key="${index}"]`);

      let optionText = $handle_option.text();   // ← here
      console.log(optionText);
      let bracketText = optionText.match(/\[(.*?)\]/);
      let finalText = bracketText ? bracketText[1] : '';

      if(!finalText){
        finalText = "Included";
      }
      console.log(finalText);

      let handleImage = handle.image;

      let handleCard = `
              <div class="shw_card pop_card" id="shwc_${index}" data-option="${index}" data-name="${handle.name}" data-property="${handle.name_properties}">
                  <img
                      class="shw_headerImg pop_img"
                      src="${handleImage}"
                      alt="${handle.name}"
                  >
                  <div class="shw_radioBtnContainer">
                      <div class="shw_radio_icon"></div> 
                       <div class="pop_name"> ${handle.name} </div>
                  </div>
                  <div class="shw_discription">${d_short}</div>
                  <div class="discription_long" style='display:none'>${d_long}</div>
                  <div class="ugw_prices">
                    <div class="ugw_salesPrice">${finalText}</div>
                  </div>
                  <div class="ugw_popup_link">
                    <div class="emu-link-icon"></div>
                  </div>
              </div>
          `;

        // Append each handle card to the container
      $(".shw_cardContainer").append(handleCard);
    });

    bindHandles();
    
    /* Caps */ 

    const allCapData = optionData.Caps || [];
    const currentCountry = getSelectedCountry();

    /*
     * Atlantis must remain available in Canada, but must not appear or
     * remain selectable in the United States.
     */
    let capData = allCapData.filter((cap) => {
      const capName = String(cap.name || "").trim().toLowerCase();

      /*
       * In the US, keep only the Standard Cover Cap.
       * This removes Atlantis, Weather Shield Cover Cap,
       * and any other premium/non-standard cap.
       */
      if (currentCountry === "US") {
        return capName.includes("standard");
      }

      return true;
    });

    /*
     * The cards are custom UI, while the Product Options app still has its
     * original select field. Disable Atlantis there as well in the US so it
     * cannot be submitted from a previous/default selection.
     */
    if (currentCountry === "US") {
      const capPropertyItem = allCapData.find((cap) => cap.name_properties);
      const capProperty = capPropertyItem ? capPropertyItem.name_properties : "";

      if (capProperty) {
        const $capSelect = $(`select[name="${capProperty}"]`);

        $capSelect.find("option").each(function () {
          const $option = $(this);
          const optionText = String($option.text() || "").trim();
          const optionKey = Number($option.attr("data-option_value_key"));
          const isEmptyOption = !$option.val() || optionKey === 0;
          const isStandardCap = /standard/i.test(optionText);

          /*
           * Keep the empty/default option and Standard Cover Cap.
           * Hide Atlantis, Weather Shield Cover Cap, and other cap upgrades.
           */
          if (!isEmptyOption && !isStandardCap) {
            $option
              .prop("disabled", true)
              .prop("selected", false)
              .attr("hidden", "hidden");
          }
        });

        const selectedCapText = String(
          $capSelect.find(":selected").text() || ""
        ).trim();

        if (
          selectedCapText &&
          !/standard/i.test(selectedCapText)
        ) {
          const $standardOption = $capSelect
            .find("option")
            .filter(function () {
              return /standard/i.test(String($(this).text() || ""));
            })
            .first();

          if ($standardOption.length) {
            $capSelect.val($standardOption.val()).trigger("change");
          } else {
            $capSelect.prop("selectedIndex", 0).trigger("change");
          }
        }
      }
    }

    // Clear existing options
    console.log("Country:", currentCountry, "Available caps:", capData);
    $(".cap_cardContainer").empty();

    // Create the cap cards allowed for the active country.
    capData.forEach((handle, index) => {
      let handlePrice = "";
      let value_key = "";

      let d_long = handle.short || '';
      let property = handle.name_properties;

      let d_short = d_long.length > 100
        ? d_long.substring(0, 100).split(' ').slice(0, -1).join(' ') + '...'
        : d_long;

      let $handle_select = $(`select[name="${property}"]`);
      let $handle_option = $handle_select.find(
        `option[data-option_value_key="${handle.index}"]`
      );

      let optionText = $handle_option.text();   // ← here
      console.log(optionText);
      let bracketText = optionText.match(/\[(.*?)\]/);
      let finalText = bracketText ? bracketText[1] : '';
      console.log(finalText);

      let handleCard = `
              <div class="cap_card pop_card" id="shwc_${index}" data-option="${handle.index}" data-name="${handle.name}" data-property="${property}">
                  <img
                      class="shw_headerImg pop_img"
                      src="${handle.image}"
                      alt="${handle.name}"
                  >
                  <div class="shw_radioBtnContainer">
                      <div class="shw_radio_icon"></div> 
                      <div class="ugw_name pop_name"> ${handle.name} </div>
                  </div>
                  <div class="shw_discription">${d_short}</div>
                  <div class="discription_long" style='display:none'>${d_long}</div>
                  <div class="ugw_prices">
                    <div class="ugw_salesPrice">${finalText}</div>
                  </div>
                  <div class="ugw_popup_link">
                    <div class="emu-link-icon"></div>
                  </div>
              </div>
          `;

        // Append each handle card to the container
      $(".cap_cardContainer").append(handleCard);
    });

    let cap_colours = optionData.Cap_Colour || [];
    let cap_color_atlantis_container = $(".cap-color-atlantis-container");

    cap_color_atlantis_container.empty();

    cap_colours.forEach((Colour) => {

      let color_card = `
        <div
          class="color-button ${Colour.name}"
          data-propertie="${Colour.name_properties}"
          ${buildDataAttrs(Colour, "us")}
          ${buildDataAttrs(Colour, "cad")}
          data-color="${Colour.name.replace(/_/g, " ")}"
          data-image="${Colour.image}"
        >
          ${Colour.name.replace(/_/g, " ")}"
        </div>
      `;
      

      if (currency == "CAD" && Colour.type=="fabric"){
        cap_color_atlantis_container.append(color_card);
      }else if (currency == "USD" && Colour.type=="weatherShield"){
        cap_color_atlantis_container.append(color_card);
      }

    });

    $(".cap-color-selector-widget").hide()

    bindCaps();

    // Loop through each accessory

    let accessoriesData = optionData.Assessories || []; // Ensure Accessories exist

    // Clear existing options before inserting new ones
    $(".ugw_cardContainer").empty();

    // Loop through each accessory option and create the corresponding HTML
    accessoriesData.forEach((accessory, index) => {
    // Skip accessories where status is 0
    if (accessory.status === 0) {
        return; // Skip this iteration
    }

    let currency = getSelectedCurrency();
    let price = "";
    let image_src = accessory.image;
    let priceText;

    $('[type="checkbox"]').each(function () {
      const $cb = $(this);

      const key    = $cb.data('option_value_key');
      const handle = $cb.data('product-handle');
      const value  = $cb.val();
      let select_handel;

       if (currency == "CAD") {
        if (accessory?.cad !== undefined) {
          index = accessory.cad.index;
          add_acc = true;
          select_handel = accessory.cad.prop;
        }else{
          add_acc = false;
        }
      } else if (currency == "USD") {
        if (accessory?.us !== undefined) {
          index = accessory.us.index;
          add_acc = true;
          select_handel = accessory.us.prop
        }else{
          add_acc = false;
        }
      }

      console.log("handle", handle, "select_handel", select_handel, index, key)

      if (handle == select_handel && index === key) {
        priceText = $cb
          .closest('.bold_option_value')        // walk up to option wrapper
          .find('.bold_option_value_price')     // then find price
          .text();

        console.log('Matched upgrade:', {
          key,
          value,
          priceText 
        });

         return false; // stop loop
      }
    });

    if(add_acc){

      let card_handel;

      if (currency == "CAD") {
        card_handel = accessory.cad.prop;
      } else if (currency == "USD") {
        card_handel = accessory.us.prop
      }
    
      let accessoryCard = `
          <div class="ugw_card pop_card" data-index="${index}" data-value="${accessory.value}" data-handel="${card_handel}" >
              <img
                  class="ugw_headerImg pop_img"
                  src="${image_src}"
                  alt="${accessory.name}"
              >
              <div class="ugw_radioBtnContainer">
                  <div class="ugw_radio_icon"></div>
                  <div class="ugw_name pop_name">${accessory.name}</div>
              </div>
              <div class="ugw_discription">${accessory.short}</div>
              <div class="discription_long" style="display:none">${accessory.long}</div>
              <div class="ugw_prices">
                  <div class="ugw_salesPrice">${priceText}</div>
              </div>
              <div class="ugw_popup_link">
                  <div class="emu-link-icon"></div>
              </div>
          </div>
      `;

      // Append each accessory card to the container
      $(".ugw_cardContainer").append(accessoryCard);
    }
  });

    bindpopup();
    bindAccessories();
    formcheck_setup();
}

function bindpopup(){
  
  $(document).on("click", ".ugw_popup_link", function (event) {
    event.stopPropagation(); // Prevent triggering body click
    console.log("popup clicked");
    
    let parentCard = $(this).closest(".pop_card");

    let imageSrc = parentCard.find(".pop_img").attr("src");
    let name = parentCard.find(".pop_name").text();
    let description = parentCard.find(".discription_long").text();

    $("#ugw_popup_image").attr("src", imageSrc);
    $("#ugw_popup_name").text(name);
    $("#ugw_popup_description").text(description);

    $("#ugw_popup").css("display", "flex");
  });

  // Close popup when clicking close button
  $(document).on("click", ".ugw_close", function () {
    $("#ugw_popup").hide();
  });

  // Close popup when clicking outside the popup content
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(".ugw_popup_content").length &&
      $("#ugw_popup").is(":visible")
    ) {
      $("#ugw_popup").hide();
    }
  });
}

function taperBinded(){
    // set the load
    const taper = $('select[name="options[Taper]"]').val();
    console.log("taper="+taper);

    $('.sdt_card').removeClass('active')
    if(taper == "5”-3”"){ 
        $('#taperCardsContainer .sdt_card')
            .filter('[data-value="5-3"]')
            .addClass('active');
    }else if(taper == "6”-4”"){
        $('#taperCardsContainer .sdt_card')
            .filter('[data-value="6-4"]')
            .addClass('active');
    }

    //
    $(".sdt_card").click(function(){
        $select = $('select[name="options[Taper]"]');
        $('.sdt_card').removeClass('active')
        meta_value = $(this).data("value");
        $(this).addClass('active');

        if(meta_value == "5-3"){
            select_value = "5”-3”";
        }else if(meta_value == "6-4"){
            select_value = "6”-4”";
        }

        $select.val(select_value).trigger('change');

        setTimeout(() => {
          $select[0].dispatchEvent(new Event("change", { bubbles: true }) );
          $select[0].dispatchEvent(new Event("input", { bubbles: true }));
          setprice()
        }, 100);
        

    })
}

function bindColors(){

  let rawDataElement = $("#option-data");
  if (!rawDataElement.length) {
    return;
  }
  
  let productData = JSON.parse(
    document.getElementById("custom-product-json").textContent
  );

  let rawData = rawDataElement.html();
  console.log("rawData",rawData)
  let optionData = JSON.parse(rawData);

  let $popup = $("#color-popup");

  const redwoodImage =
    "https://cdn.shopify.com/s/files/1/0575/1249/3261/files/Weather_Shield_Redwood.png?v=1783956753&width=250";

  const redwoodName =
    "WeatherShield Redwood";

  $(".color-button").hover(
    function (event) {
      let colorName = $(this).attr("data-color");
      let imageUrl = $(this).attr("data-image");

      if ($(this).hasClass("weather_coffee_brown")) {
        colorName = redwoodName;
        imageUrl = redwoodImage;

        $(this)
          .attr("data-color", redwoodName)
          .data("color", redwoodName)
          .attr("data-image", redwoodImage)
          .data("image", redwoodImage);
      }

      // Update popup content
      $popup.text(colorName);
      $popup.css({
        "background-image": `url("${imageUrl}")`,
        "display": "flex",
      });

      // Position the popup near the hovered button
      let offset = $(this).offset();

      if (offset) {
        $popup.css({
          "top": offset.top - 320 + "px",
          "left": offset.left + 50 + "px"
        });
      }
    },
    function () {
      $popup.hide();
    }
  );

  $(".color-button").on("click", function () {
    // Remove 'selected' class from all buttons and add it to the clicked one
    $(".color-button").removeClass("selected");
    $(this).addClass("selected");
    let color_name = $(this).data("color");

    color_name = (color_name || "").replace(/_/g, " ");
    $(".dtext_target").html(color_name);

    let currency = getSelectedCurrency();
    let selected_index = 0;
    prop = $(this).data('propertie')
    selected_index = $(this).data('index')

    console.log("prop:"+prop);
    console.log("selected_index:"+selected_index);
    

    let $select_standard_color = $(`select[name="${optionData.Colour_handels[0].handels}"]`);
    let $select_atlantis_color = $(`select[name="${optionData.Colour_handels[1].handels}"]`);
    let $select_weather_color  = $(`select[name="${optionData.Colour_handels[2].handels}"]`);

    console.log(optionData.Colour_handels[0].handels);

    if ($select_atlantis_color.length) {
      console.log("elect_atlantis_color color select found");
    } else {
      console.warn(`select_atlantis_color color select NOT found`);
    }

    if(prop == optionData.Colour_handels[1].handels){
      console.log("atlantis-tigger");

      let $option = $select_atlantis_color.find(
        `option[data-option_value_key="${selected_index}"]`
      );

      let optionText = $option.text();   // ← here
      console.log(optionText); 
      optionText = (optionText || "").replace(/_/g, " ");
      $(".dtext_target").html(optionText);

      $select_atlantis_color.val($option.val()).trigger('change');
      $select_weather_color.val("");
      $select_standard_color.val("");

    }else if(prop == optionData.Colour_handels[2].handels){

      console.log("Weather Shield Colour");
      let $option = $select_weather_color.find(
        `option[data-option_value_key="${selected_index}"]`
      );

      let optionText = $option.text();   // ← here
      optionText = (optionText || "").replace(/_/g, " ");
      $(".dtext_target").html(optionText);

      $select_weather_color.val($option.val()).trigger('change');
      $select_standard_color.val("");
      $select_atlantis_color.val("");

    }else{
      let $option = $select_standard_color.find(
        `option[data-option_value_key="${selected_index}"]`
      );

      let optionText = $option.text();   // ← here
      console.log(optionText);
      optionText = (optionText || "").replace(/_/g, " ");
      $(".dtext_target").html(optionText);

      $select_standard_color.val($option.val()).trigger('change');
      $select_atlantis_color.val("");
      $select_weather_color.val("");
    }
    
    setTimeout(() => {
      $select_weather_color[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_weather_color[0].dispatchEvent(new Event("input", { bubbles: true }));

      $select_atlantis_color[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_atlantis_color[0].dispatchEvent(new Event("input", { bubbles: true }));

      $select_standard_color[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_standard_color[0].dispatchEvent(new Event("input", { bubbles: true }));

      setprice()

    }, 100);
    
    
  });
  
}

function bindCaps(){
  $(".cap_card").on("click", function () {

    let indexKey;
    let property = $(this).data("property");
    let $select_main_handel = $(`select[name="${property}"]`);
    const $card = $(this);

    if ($card.hasClass('active')) {
      // deselect if clicking the active one
      $card.removeClass('active');
      option_index = 0
    } else {
      // deactivate others, activate this one

      $('.cap_card').removeClass('active');
      $card.addClass('active');
      option_index = $card.data("option")
    }

    console.log("option_index",option_index)
    if(option_index == 2){ 
      $(".cap-color-selector-widget").show()
    } else{
      $(".cap-color-selector-widget").hide() 

      $(".cap-color-selector-widget .color-button").removeClass("selected");
      $(".cap-color-selector-widget .dtext_target").html("");
      let $select_atlantis_cap_color = $('input[name="properties[Cover Cap Color]"]');
      $select_atlantis_cap_color.val("").trigger('change');
      $select_atlantis_cap_color[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_atlantis_cap_color[0].dispatchEvent(new Event("input", { bubbles: true }));
    
    }

    /// set main 
   
    if (!$select_main_handel.length) return;

    let  $option_main_handel = $select_main_handel.find(
      `option[data-option_value_key="${option_index}"]`
    );

    if ($option_main_handel.length) {
      $select_main_handel.val($option_main_handel.val()).trigger('change');

      setTimeout(() => {
        $select_main_handel[0].dispatchEvent(new Event("change", { bubbles: true }) );
        $select_main_handel[0].dispatchEvent(new Event("input", { bubbles: true }));
        setprice()
      }, 100);

    }
  })

  let $popup = $(".cap-cover.color-popup");

  $(".cap-color-selector-widget .color-button").hover(
    function (event) {
      console.log("cap color hover");
      let colorName = $(this).data("color");
      let imageUrl = $(this).data("image");

      // Update popup content
      $popup.text(colorName);
      $popup.css({
        "background-image": `url(${imageUrl})`,
        "display": "flex",
      });

      // Position the popup near the hovered button
      let offset = $(this).offset();
      $popup.css({
        "top": offset.top - 320 + "px",
        "left": offset.left + 50 + "px"
      });
    },
    function () {
      $popup.hide();
    }
  );

  $(".cap-color-selector-widget .color-button").on("click", function () {
    // Remove 'selected' class from all buttons and add it to the clicked one
    $(".cap-color-selector-widget .color-button").removeClass("selected");
    $(this).addClass("selected");
    let color_name = $(this).data("color");

    $(".cap-color-selector-widget .dtext_target").html(color_name);
    let $select_atlantis_cap_color = $('input[name="properties[Cover Cap Color]"]');

    $select_atlantis_cap_color.val(color_name).trigger('change');

    
    setTimeout(() => {
      $select_atlantis_cap_color[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_atlantis_cap_color[0].dispatchEvent(new Event("input", { bubbles: true }));

      setprice()

    }, 100);
    
    

  });




}

function bindHandles(){
  $(".shw_card").on("click", function () {

    let indexKey;
    let property = $(this).data("property")
    let $select_main_handel = $(`select[name="${property}"]`);
    let $select_ui_handel = $('.fsk-handel-count');

    $(".shw_card").removeClass("active");
    $(this).addClass("active");
    
    option_index = $(this).data("option")

    /// set main 
   
    if (!$select_main_handel.length) return;

    let  $option_main_handel = $select_main_handel.find(
      `option[data-option_value_key="${option_index}"]`
    );

    if ($option_main_handel.length) {
      $select_main_handel.val($option_main_handel.val()).trigger('change');

      setTimeout(() => {
        $select_main_handel[0].dispatchEvent(new Event("change", { bubbles: true }) );
        $select_main_handel[0].dispatchEvent(new Event("input", { bubbles: true }));
        setprice()
      }, 100);

    }
  })

  $(".fsk-handel-count").on('change', function () {

     let $select_main_handel = $('select[name="properties[Handles]"]');

     $select_main_handel.val($(this).val()).trigger('change');

    setTimeout(() => {
      $select_main_handel[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_main_handel[0].dispatchEvent(new Event("input", { bubbles: true }));
      setprice()
    }, 100);

  });

}

function bindAccessories() {

  $(document)
    .off("click.accessoryCard", ".ugw_card")
    .on("click.accessoryCard", ".ugw_card", function (event) {

      // Prevent popup click from selecting accessory
      if (
        $(event.target).closest(".ugw_popup_link").length
      ) {
        return;
      }

      const $clicked = $(this);

      const selectKey = Number(
        $clicked.data("index")
      );

      const selectHandle = String(
        $clicked.data("handel") || ""
      );

      // Toggle custom card
      $clicked.toggleClass("active");

      const shouldCheck =
        $clicked.hasClass("active");

      /*
       * Find ALL SC checkboxes matching
       * this exact upgrade.
       */
      const $matches = $('[type="checkbox"]').filter(function () {

        const $cb = $(this);

        const key = Number(
          $cb.data("option_value_key")
        );

        const handle = String(
          $cb.data("product-handle") || ""
        );

        return (
          handle === selectHandle &&
          key === selectKey
        );

      });

      console.log(
        "Matching upgrade checkboxes:",
        $matches.length,
        {
          selectHandle,
          selectKey
        }
      );

      if (!$matches.length) {

        console.warn(
          "❌ No matching SC checkbox found:",
          selectHandle,
          selectKey
        );

        $clicked.removeClass("active");

        return;
      }

      /*
       * IMPORTANT:
       * Only ONE matching checkbox should remain selected.
       *
       * If SC generated duplicate US checkboxes,
       * all duplicates after the first are forced OFF.
       */
      $matches.each(function (index) {

        const $cb = $(this);

        const newState =
          index === 0
            ? shouldCheck
            : false;

        const oldState =
          $cb.prop("checked");

        /*
         * Only dispatch when state actually changes.
         */
        if (oldState !== newState) {

          $cb.prop(
            "checked",
            newState
          );

          if ($cb[0]) {

            $cb[0].dispatchEvent(
              new Event(
                "change",
                {
                  bubbles: true
                }
              )
            );

          }
        }

        console.log(
          "SC checkbox:",
          index,
          {
            value: $cb.val(),
            checked: newState,
            handle:
              $cb.data(
                "product-handle"
              ),
            key:
              $cb.data(
                "option_value_key"
              )
          }
        );

      });

      /*
       * Let SC finish recalculating before
       * reading .bold_option_total.
       */
      setTimeout(function () {

        setprice();

        console.log(
          "✅ Accessory sync complete"
        );

      }, 200);

    });

}

function formcheck_setup(){
  function showFormErrors(messages) {
    const $errorBox = $(".errorMessage");

    if (!messages.length) {
      $errorBox.html("").hide();
      return;
    }

    $errorBox.html(messages.join("<br>")).show();

    $("html, body").animate({
      scrollTop: $errorBox.offset().top - 20
    }, 400);
  }

  function getFormErrors() {
    const messages = [];
    const capSelection = $(".cap_card.active").data("option");
    const mainColorSelected = [
      ".us-color-button-container .color-button.selected",
      ".color-standard-container .color-button.selected",
      ".color-atlantis-container .color-button.selected",
      ".weatherShield-color-container .color-button.selected"
    ].some((selector) => $(selector).length > 0);

    if ($(".sdt_card.active").length === 0) {
      messages.push("Select taper");
    }

    if (!mainColorSelected) {
      messages.push("Select color");
    }

    if ($(".shw_card.active").length === 0) {
      messages.push("Select handles");
    }

    if (String(capSelection) === "2" && !$.trim($('input[name="properties[Cover Cap Color]"]').val())) {
      messages.push("Select cap cover color");
    }

    return messages;
  }

  $(".custom-add-to-cart").off("click.scAValidation").on("click.scAValidation", function (event) {
    event.preventDefault();

    const errors = getFormErrors();
    if (errors.length) {
      showFormErrors(errors);
      return;
    }

    showFormErrors([]);
    $(".product-form__submit.bold_hidden").trigger("click");
  });

  $(".product-form").off("submit.scAValidation").on("submit.scAValidation", function (event) {
    const errors = getFormErrors();
    if (!errors.length) {
      showFormErrors([]);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    showFormErrors(errors);
  });

}

function getUrlParameter(name) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " ")).replace(/-/g, ' '); // Convert hyphens back to spaces
}

$(document).ready(function () {
  console.log("Wait for product-form to load before running the script");
  let checkFormInterval = setInterval(() => {
    console.log(
      "check bold_option  :" + $(".bold_option").length
    );
    if ($(".bold_option").length > 3) {
      clearInterval(checkFormInterval);
      importMeta();
      setVariant() 
    }
  }, 500);

  console.log("openCart: " + getUrlParameter("openCart"));
  console.log("cupcake: " + getUrlParameter("cupcake"));

  if(getUrlParameter("cupcake") == "1"){
    $("div#custom_hidden_buttons").show();
  }

  if (getUrlParameter("openCart") == "1") {
    const $cartDrawer = $("cart-drawer.drawer");
    if ($cartDrawer.length) {
      console.log("🛒 Opening cart drawer after 3 seconds active...");

      // ✅ Add the 'active' class to open the drawer
      $cartDrawer.addClass("active");

      // ✅ Focus on the cart drawer for better UX
      $cartDrawer.focus();
    }
  }
});